<script>
    import { goto } from '$app/navigation';
    import { fade } from 'svelte/transition';
    let { text = 'text', click } = $props();
    let hover = $state(false);
    let width = $state();
    let height = $state();

</script>

<!-- <a data-koalendar-widget href={href}> -->

<div class="f-col align-cc">
        <button 
            class="" 
            onclick={goto(click)}
            onmouseenter={() => hover = true}
            onmouseleave={() => hover = false}
            bind:clientWidth={width}
            bind:clientHeight={height}
            >
            {text}
        </button>
        {#if hover}
        <div 
            class="shadow"
            style="
            width: calc({width}px * 1.025); 
            height: calc({height}px * 1.25);
            "
            transition:fade
        ></div>
        {/if}
    </div>
<!-- </a> -->

<style>
button {
    z-index: 2;
    padding: 1.75rem 3rem;
    /* margin: 3rem 0; */
    /* font-family: 'Bitter Variable', serif; */
    font-family: 'Inter Variable', sans-serif;
    font-size: clamp(1.125rem, -2.533rem + 4.5vw , 1.525rem);
    font-weight: 700;
    color: black;
    white-space: nowrap;
    transition: all .3s ease;
}

button:hover {
    transform: translateY(-12px);
}

button::after,
button::before,
button:visited {
    color: black;
}

button, .shadow {
    border-radius: 3.5rem;
}

.shadow {
    color: rgba(255,255,255,0.9);
    background: linear-gradient(-45deg, #f6ff00, #FF3D77, hsl(230, 100%, 58%), #1dffca);
    background-size: 600%;
    animation: bg-slide 10s ease infinite;
      }

  .shadow {
    z-index: 1;
     position: absolute;
     margin-top: -20px;
     filter: blur(30px);
     opacity: 0.8;
  }


@media (max-width: 768px) {
    button {
        margin: 1.5rem 0;
        font-size: 1.675rem;
    }
}

     
 @keyframes bg-slide { 
   0% {
     background-position: 0% 50%;
   }
   50% {
     background-position: 100% 50%;
   }
   100%{
     background-position: 0% 50%;
 }
}
</style>